import fromChannels from '../data/fromChannels'
const getFromChannel = fromChannel => {
    if (['', fromChannels.SDB].includes(fromChannel)) return fromChannels.SDB
    return fromChannel
}

export default getFromChannel